import { Alert } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { availableFrom, availableTo } from '@app/configs/dateTime';
import { mapLithuanianToLocalTime } from '@app/utils/time';
const ServiceAvailability = () => {
    const { t } = useTranslation();
    const from = mapLithuanianToLocalTime(availableFrom);
    const to = mapLithuanianToLocalTime(availableTo);
    return (<Alert title={t('financing.service_availability.title')} variant="info">
            <div className="body-m">{t('financing.service_availability.message', { from, to })}</div>
        </Alert>);
};
export default ServiceAvailability;
